// add function for numbers to to round to however many places you provide
//only rounds as needed. Does not add decimal places for whole numbers
import azState from "../../assets/az_state.png";
import polymap from "../../assets/poly_map.png";
import donut from "../../assets/ring_chart.png";
import area from "../../assets/area_chart.png";
import pie from "../../assets/gauge_pie_chart.png";


export const decimalRoundHelper = (num, places = 2) => {
  places = Math.pow(10, places);
  return Math.round(num * places) / places;
};

export function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}

export function get_change(current, previous) {
  if (current === previous) {
    return 0;
  }
  return Math.round(
    (Math.abs(current - previous) / ((current + previous) / 2)) * 100,
    2
  );
}

export function calculateLegendLabels(sliderValue, scenario) {
  let percentChange;
  if (scenario === "DCP Cuts") {
    percentChange = get_change(sliderValue, 1300000);
  } else {
    percentChange = get_change(sliderValue, 700000);
  }
  const difference = percentChange / 5;
  const legendLabels = [0];
  let current = 0;
  for (let i = 0; i < 5; i++) {
    legendLabels.push(decimalRoundHelper((current += difference), 2));
  }
  return legendLabels;
}

export const nameParser = (word) => {
  return word.toLowerCase().replace(/ /g, '_');
}

export const nameReverseParser = (str) => {
  let c = str || '';
  let i, words = c.split('_');
  for (i=0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }
  return words?.join(' ');
}

export const getDropDownRange = (data) => {
  if (Object.keys(data).length) {
    let input = Object.keys(data)
    let noOfIternation = Math.floor(input.length/5)
    let number = 0
    let result = []
    let index = 0
    while(number < noOfIternation) {
      result.push(`${input[index]}-${input[index+4]}`)
      index = index + 5
      number++
    }
    if(input.length%5 !== 0) {
      let lastElement = result[result.length - 1]
      let [start, end] = lastElement.split("-")
      end = parseInt(end) + input.length%5
      result[result.length - 1] = `${start}-${end}`
    }
    result = result.map((val) => {
      return {
        label: val,
        value: val,
      }
    })
    return result
  }
  return [];
}

export const hideDropdown = ['central_az_water_use', 'colorado_river_water_access']

export const defaultScenarioData = [
  {
      label: '2024-2028',
      value: '2024-2028'
  },
  {
      label: '2029-2033',
      value: '2029-2033'
  },
  {
    label: '2034-2038',
    value: '2034-2038'
  },
  {
    label: '2039-2043',
    value: '2039-2043'
  },
  {
      label: '2044-2048',
      value: '2044-2048'
  },
  {
    label: '2049-2053',
    value: '2049-2053'
  },
]

export const defaultSliderRange = [
  {
    value: 2024,
    label: "2024",
  },
  {
    value: 2025,
    label: "2025",
  },
  {
    value: 2026,
    label: "2026",
  },
  {
    value: 2027,
    label: "2027",
  },
  {
    value: 2028,
    label: "2028",
  },
]

export const sliderValues = {
  min_value: 2024,
  max_value: 2060,
  range: [{value: 2024, label: '2024'}, {value: 2060, label: '2060'}]
}

export const years_data = ["2024", "2030", "2036", "2042", "2048", "2054", "2060"]

export const generateYearRange = (startYear = 2024, endYear = 2060) => {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
};

export const xLabels = [2024, 2030, 2036, 2042, 2048, 2054, 2060]

export const listOfFeatureSettings = [
  'colarado_river_water_access',
  'central_arizona_colorado_river_water_access_per_person_municipal_areas',
  'central_arizona_water_deliveries_and_uses',
  'colorado_river_access_by_water_priority_level',
  'central_arizona_colorado_river_water_use_vs_access',
]

export const TabPanelData = {
  colarado_river_water_access: {
    key: 'colorado_river_access',
    label: 'colorado_river_access',
    icon: azState,
    value: 'Colorado River Water Access'
  },
  central_arizona_colorado_river_water_access_per_person_municipal_areas: {
    key: 'access_per_capita',
    label: 'access_per_capita',
    icon: polymap,
    value: 'Central Arizona Colorado River Water Access Per Person - Municipal Areas',
  },
  central_arizona_water_deliveries_and_uses: {
    key: 'central_az_water_use',
    label: 'central_az_water_use',
    icon: donut,
    value: 'Central Arizona Water Deliveries and Uses - 2020'
  },
  colorado_river_access_by_water_priority_level: {
    key: 'colorado_river_water_access',
    label: 'colorado_river_water_access',
    icon: area,
    value: 'Colorado River Access by Water Priority Level'
  },
  central_arizona_colorado_river_water_use_vs_access: {
    key: 'water_use_versus_access',
    label: 'water_use_versus_access',
    icon: pie,
    value: 'Central Arizona Colorado River Water Use vs. Access'
  },
}